<template>
    <v-card class="elevation-12" >
        <v-toolbar dark color="warning">
            <v-toolbar-title>{{trans('auth-pages.verify.title') }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <error-badge v-model="error"></error-badge>
            {{ trans('auth-pages.verify.text') }}
            <div class="mt-2">
            {{trans('auth-pages.verify.resend-text')}}
            </div>
            <v-alert type="success" v-if="resent">{{ trans('auth-pages.verify.success-message') }}</v-alert>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text
                @click="resend"
                :loading="loading"
                :disabled="resent"
                ><v-icon left>refresh</v-icon>{{trans('auth-pages.verify.resend-btn')}}</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
    export default {
        name: "verify",
        props: {
            action:{type:String,default:'/password/email'},
        },
        data() {
            return {
                loading:false,
                resent:false,
                error:null,
            }
        },
        methods: {
            back(){this.$emit('back')},
            resend(){
                this.resent =  false;
                this.loading =  true;
                this.error =  null;
                axios.post(this.action)
                    .then(r=>{
                        this.resent=true;
                        setTimeout(()=>{
                                this.resent=false;//Dismiss after X seconds
                            },10000);
                    })
                    .catch(e=>{this.error=e;})
                    .finally(()=>{this.loading=false;});
            },
        }
    }
</script>
